<script>
  import { createEventDispatcher } from "svelte";
  import { SkeletonText } from "carbon-components-svelte";
  import { Accordion } from "paxray-components-svelte";

  export let loading = false;
  export let departments = [];
  export let selectedData = { department: null, area: null, task: null };
  export let elementSelected = null;
  export let formatScore = () => "";
  export let scoreTone = () => "";
  export let isGroupSelected = () => false;
  export let isGroupPartiallySelected = () => false;
  export let isTaskSelected = () => false;
  export let withAccordion = true;

  const dispatch = createEventDispatcher();
</script>

{#if withAccordion}
  <Accordion open={true}>
    <span slot="heading" class="hierarchy_accordion_heading">
      <strong>Hierarchy</strong>
    </span>
    <div class="hierarchy_content">
      <div class="hierarchy_tree">
        {#if loading}
          <SkeletonText />
        {:else if departments.length === 0}
          <div class="hierarchy_empty">No matching results</div>
        {:else}
          {#each departments as department}
            <details class="hierarchy_department" open>
            <summary class="hierarchy_department_row">
              <span class="hierarchy_chevron" aria-hidden="true"></span>
              <input
                class="hierarchy_checkbox"
                type="checkbox"
                checked={isGroupSelected(department)}
                indeterminate={isGroupPartiallySelected(department)}
                on:click|stopPropagation={() => {}}
                on:change={(event) =>
                  dispatch("toggleGroup", {
                    element: department,
                    selected: event.currentTarget.checked,
                  })}
              />
              <button
                type="button"
                class="hierarchy_department_select"
                class:selected={selectedData.department === department.id}
                on:click|preventDefault|stopPropagation={() =>
                  dispatch("selectDepartment", department)}
              >
                <strong title={department.name}>{department.name}</strong>
                <span class="hierarchy_score {scoreTone(department)}">{formatScore(department)}</span>
              </button>
            </summary>

            <div class="hierarchy_areas">
              {#each department.areas as area}
                <details class="hierarchy_area_group">
                  <summary
                    class="hierarchy_area"
                    class:selected={elementSelected?.id === area.id}
                  >
                    <span class="hierarchy_chevron" aria-hidden="true"></span>
                    <input
                      class="hierarchy_checkbox"
                      type="checkbox"
                      checked={isGroupSelected(area)}
                      indeterminate={isGroupPartiallySelected(area)}
                      on:click|stopPropagation={() => {}}
                      on:change={(event) =>
                        dispatch("toggleGroup", {
                          element: area,
                          selected: event.currentTarget.checked,
                        })}
                    />
                    <button
                      type="button"
                      class="hierarchy_area_select"
                      on:click|preventDefault|stopPropagation={() =>
                        dispatch("openElement", {
                          element: area,
                          type: "area",
                          context: department.name,
                        })}
                    >
                      <span title={area.name}>{area.name}</span>
                      <strong class="hierarchy_score {scoreTone(area)}">{formatScore(area)}</strong>
                    </button>
                  </summary>
                  <div class="hierarchy_tasks">
                    {#each area.tasks || [] as task}
                      <div
                        class="hierarchy_task"
                        class:selected={elementSelected?.id === task.id}
                      >
                        <input
                          class="hierarchy_checkbox"
                          type="checkbox"
                          checked={isTaskSelected(task.id)}
                          on:change={(event) =>
                            dispatch("toggleTask", {
                              task,
                              selected: event.currentTarget.checked,
                            })}
                        />
                        <button
                          type="button"
                          class="hierarchy_task_select"
                          on:click={() =>
                            dispatch("openElement", {
                              element: task,
                              type: "task",
                              context: `${department.name} · ${area.name}`,
                            })}
                        >
                          <span title={task.name}>{task.name}</span>
                          <strong class="hierarchy_score {scoreTone(task)}">{formatScore(task)}</strong>
                        </button>
                      </div>
                    {/each}
                  </div>
                </details>
              {/each}
            </div>
            </details>
          {/each}
        {/if}
      </div>
    </div>
  </Accordion>
{:else}
  <div class="hierarchy_content">
    <div class="hierarchy_tree">
      {#if loading}
        <SkeletonText />
      {:else if departments.length === 0}
        <div class="hierarchy_empty">No matching results</div>
      {:else}
        {#each departments as department}
          <details class="hierarchy_department" open>
            <summary class="hierarchy_department_row">
              <span class="hierarchy_chevron" aria-hidden="true"></span>
              <input
                class="hierarchy_checkbox"
                type="checkbox"
                checked={isGroupSelected(department)}
                indeterminate={isGroupPartiallySelected(department)}
                on:click|stopPropagation={() => {}}
                on:change={(event) =>
                  dispatch("toggleGroup", {
                    element: department,
                    selected: event.currentTarget.checked,
                  })}
              />
              <button
                type="button"
                class="hierarchy_department_select"
                class:selected={selectedData.department === department.id}
                on:click|preventDefault|stopPropagation={() =>
                  dispatch("selectDepartment", department)}
              >
                <strong title={department.name}>{department.name}</strong>
                <span class="hierarchy_score {scoreTone(department)}">{formatScore(department)}</span>
              </button>
            </summary>

            <div class="hierarchy_areas">
              {#each department.areas as area}
                <details class="hierarchy_area_group">
                  <summary
                    class="hierarchy_area"
                    class:selected={elementSelected?.id === area.id}
                  >
                    <span class="hierarchy_chevron" aria-hidden="true"></span>
                    <input
                      class="hierarchy_checkbox"
                      type="checkbox"
                      checked={isGroupSelected(area)}
                      indeterminate={isGroupPartiallySelected(area)}
                      on:click|stopPropagation={() => {}}
                      on:change={(event) =>
                        dispatch("toggleGroup", {
                          element: area,
                          selected: event.currentTarget.checked,
                        })}
                    />
                    <button
                      type="button"
                      class="hierarchy_area_select"
                      on:click|preventDefault|stopPropagation={() =>
                        dispatch("openElement", {
                          element: area,
                          type: "area",
                          context: department.name,
                        })}
                    >
                      <span title={area.name}>{area.name}</span>
                      <strong class="hierarchy_score {scoreTone(area)}">{formatScore(area)}</strong>
                    </button>
                  </summary>
                  <div class="hierarchy_tasks">
                    {#each area.tasks || [] as task}
                      <div
                        class="hierarchy_task"
                        class:selected={elementSelected?.id === task.id}
                      >
                        <input
                          class="hierarchy_checkbox"
                          type="checkbox"
                          checked={isTaskSelected(task.id)}
                          on:change={(event) =>
                            dispatch("toggleTask", {
                              task,
                              selected: event.currentTarget.checked,
                            })}
                        />
                        <button
                          type="button"
                          class="hierarchy_task_select"
                          on:click={() =>
                            dispatch("openElement", {
                              element: task,
                              type: "task",
                              context: `${department.name} · ${area.name}`,
                            })}
                        >
                          <span title={task.name}>{task.name}</span>
                          <strong class="hierarchy_score {scoreTone(task)}">{formatScore(task)}</strong>
                        </button>
                      </div>
                    {/each}
                  </div>
                </details>
              {/each}
            </div>
          </details>
        {/each}
      {/if}
    </div>
  </div>
{/if}

<style>
  .hierarchy_content {
    min-height: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .hierarchy_accordion_heading {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
  }

  .hierarchy_tree {
    flex: 1;
    overflow-y: auto;
    padding: 0;
  }

  .hierarchy_department + .hierarchy_department {
    margin-top: 0.45rem;
  }

  .hierarchy_department > summary,
  .hierarchy_area_group > summary {
    list-style: none;
  }

  .hierarchy_department > summary::-webkit-details-marker,
  .hierarchy_area_group > summary::-webkit-details-marker {
    display: none;
  }

  .hierarchy_department_row {
    display: grid;
    grid-template-columns: 1rem 1rem minmax(0, 1fr);
    align-items: center;
    gap: 0.25rem;
    cursor: pointer;
  }

  .hierarchy_department_select,
  .hierarchy_area,
  .hierarchy_task,
  .hierarchy_area_select,
  .hierarchy_task_select {
    min-width: 0;
    border: 1px solid transparent;
    border-radius: 0.4rem;
    background: transparent;
    color: var(--pax-black);
    text-align: left;
    cursor: pointer;
  }

  .hierarchy_department_select {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 0.5rem;
    padding: 0.25rem 0.35rem;
  }

  .hierarchy_department_select:hover,
  .hierarchy_department_select.selected,
  .hierarchy_area:hover,
  .hierarchy_area.selected,
  .hierarchy_task:hover,
  .hierarchy_task.selected {
    border-color: var(--pax-black);
    background: transparent;
  }

  .hierarchy_department_select strong,
  .hierarchy_area_select > span,
  .hierarchy_task_select > span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .hierarchy_department_select strong {
    font-size: 0.9375rem;
  }

  .hierarchy_score {
    flex-shrink: 0;
    min-width: 2.35rem;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    padding: 0.2rem 0.45rem;
    color: var(--pax-black);
    font-size: 0.86rem;
    font-weight: 600;
    line-height: 1;
  }

  .score_good {
    border: 1px solid #8fc99b;
    background: #d9f4df;
  }

  .score_medium {
    background: var(--pax-white);
  }

  .score_risk {
    border: 1px solid #cf8f92;
    background: #f6d5d6;
  }

  .hierarchy_areas {
    margin: 0.25rem 0 0 1.25rem;
    padding-left: 0.55rem;
  }

  .hierarchy_area {
    width: 100%;
    display: grid;
    grid-template-columns: 1rem 1rem minmax(0, 1fr);
    align-items: center;
    gap: 0.35rem;
    padding: 0.3rem 0.3rem;
    font-size: 0.9375rem;
    cursor: pointer;
  }

  .hierarchy_area_select {
    width: 100%;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 0.35rem;
    padding: 0.15rem 0;
  }

  .hierarchy_tasks {
    margin-left: 0.75rem;
  }

  .hierarchy_task {
    width: 100%;
    display: grid;
    grid-template-columns: 1rem minmax(0, 1fr);
    align-items: center;
    gap: 0.35rem;
    padding: 0.28rem 0.4rem 0.28rem 0.75rem;
    color: #5f6770;
    font-size: 0.875rem;
  }

  .hierarchy_task_select {
    width: 100%;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 0.35rem;
    padding: 0.15rem 0;
    color: inherit;
  }

  .hierarchy_checkbox {
    width: 0.9rem;
    height: 0.9rem;
    margin: 0;
    accent-color: var(--pax-orange);
    cursor: pointer;
  }

  .hierarchy_chevron {
    width: 0.45rem;
    height: 0.45rem;
    border-right: 1.5px solid var(--pax-black);
    border-bottom: 1.5px solid var(--pax-black);
    transform: rotate(-45deg);
    transition: transform 0.15s ease;
  }

  details[open] > summary > .hierarchy_chevron {
    transform: rotate(45deg);
  }

  .hierarchy_empty {
    padding: 1rem;
    border-radius: 0.45rem;
    background: #f6f6f7;
    color: var(--pax-sub, #5f6770);
    text-align: center;
    font-size: 0.75rem;
  }
</style>
